const SalesProjection = {
  "cannot edit because a manufacture was included by copilot": "Não é possível editar porque uma produção foi incluída via copiloto.",
};

export default SalesProjection;